import { Card, Col, Flex, Row, Tag, Typography } from "antd";
import Image from "next/image";
import { useIntl } from "react-intl";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { ISaveServiceRequestDetailsResponse } from "../../Orchestrator/Types/Interface/IServiceRequest";
import { _eventBus } from "../../core/events/EventBus";
import { useParams } from "next/navigation";
import { srReqClaimTree } from "../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";

const ServiceRequestCount = () => {
  const intl = useIntl();
  const [requestList] = useRecState<ISaveServiceRequestDetailsResponse[]>(
    "serviceRequestTicketListAtom"
  );
  const params = useParams();
  const bookingId = params.booking_id;

  const handleSRClick = () => {
    _eventBus.emit({
      eventName: srReqClaimTree.RequestClaim.ClaimDetail,
      data: bookingId,
    });
  };

  if (requestList.length === 0) return <></>;
  return (
    <Card className="card-shadow mb-20">
      <Row gutter={10} align={"middle"}>
        <Col span={22}>
          <Typography.Text className="fs-14 fw-600 ff-inter">
            Requests & Claims
          </Typography.Text>
        </Col>
        <Col span={2} onClick={handleSRClick} className="cursor-pointer">
          <Flex justify="end">
            <Tag color="#f3e6dd" className="cursor-pointer">
              <Typography.Text className="fs-13 fw-400 ff-inter">
                {requestList.length}
              </Typography.Text>
            </Tag>
            <Image
              src={"/assets/booking/right_arrow.svg"}
              height={25}
              width={25}
              alt="service request"
              className="cursor-pointer arabic-rotate"
            />
          </Flex>
        </Col>
      </Row>
    </Card>
  );
};

export default ServiceRequestCount;
